module.exports = __webpack_public_path__ + "files/74be5a878eb05342b0c8e57525e40876.svg";